import "./reset-password.css";
import { useSupabaseClient } from "@/hooks/useSupabaseClient";
import { useNavigate } from "react-router-dom";
import UpdatePassword from "../../components/UpdatePassword";
import { LOGIN } from "@/constant/routes";



  
const ResetPassword = () => {

  const supabase = useSupabaseClient();
  const navigate = useNavigate();

  const onClick = async (password: string) => {
        
    const { error } = await supabase.auth.updateUser(
      {password},
    )

    if (error) {
        console.log(error);
        return;
    }
    navigate(LOGIN);

  }
  
    return (
      <UpdatePassword 
        description={"Votre mot de passe doit contenir au moins 12 caractères, dont une majuscule, un chiffre et un symbole"} 
        title={"Réinitialisation votre mot de passe"}
        onClick={onClick}/>   
    );
};

export default ResetPassword